import { ZardDialogService } from '../../ui-components';
import type { SettingsDialogData } from './settings-dialog.component';
import { wrapChunkLoad } from '../../../services/chunk-loading.service';

// The dialog exists at most once; opens arriving while its chunk loads do not create another.
let pendingOpen: Promise<boolean> | null = null;

/** Whether a settings dialog is being loaded right now. */
export function settingsDialogOpening(): boolean {
  return pendingOpen !== null;
}

/**
 * Dynamically loads the settings dialog so it stays out of the authenticated shell chunk.
 * Resolves to whether this call created the dialog with its `data`; it does not when another
 * open is loading or a settings dialog is already open.
 */
export function openSettingsDialog(
  dialog: ZardDialogService,
  data?: SettingsDialogData,
): Promise<boolean> {
  if (pendingOpen) {
    return pendingOpen.then(() => false);
  }
  pendingOpen = (async () => {
    try {
      const { SettingsDialogComponent } = await wrapChunkLoad(
        import('./settings-dialog.component'),
      );
      if (SettingsDialogComponent.isOpen) {
        return false;
      }
      SettingsDialogComponent.open(dialog, data);
      return true;
    } finally {
      pendingOpen = null;
    }
  })();
  return pendingOpen;
}
